import { twMerge } from "tailwind-merge"

interface RadioInputButtonProps {
  className?: string
  emoji?: string
  label?: string
  name: string
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  text?: string
  value: string
}

export default function RadioInputButton({
  className,
  emoji,
  label,
  name,
  onChange,
  text,
  value,
}: RadioInputButtonProps) {
  const emojiSize = label ? "text-normal" : "text-3xl"

  return (
    <label
      className={twMerge(
        "theme-button-input flex items-center gap-4",
        className,
      )}
    >
      <input
        className="hidden"
        name={name}
        onChange={onChange}
        type="radio"
        value={value}
      />

      {emoji && (
        <span className={twMerge("emoji", emojiSize, "mr-1")}>{emoji}</span>
      )}

      {label}

      {text && (
        <>
          <br />
          <span className="text-xs">{text}</span>
        </>
      )}
    </label>
  )
}
